import ArticleContainer from './ArticleContainer';

export default ArticleContainer;
